import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ShieldCheck, Phone } from "lucide-react";
import { markPoliceCalled } from "@/lib/alerts";
import { formatApiError } from "@/lib/api";
import { formatTimeFr } from "@/lib/format";
import ConfirmDialog from "@/components/ConfirmDialog";

export default function PoliceCalledBlock({ alert, onUpdated }) {
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const called = Boolean(alert.police_called_at);

  if (called) {
    return (
      <div
        className="sa-card flex items-start gap-3 px-4 py-4"
        data-testid="police-called-done"
      >
        <div
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white"
          style={{ background: "#3B82F6" }}
        >
          <ShieldCheck size={18} />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <span className="text-[13.5px] font-semibold text-slate-900">
            Police / secours contactés
          </span>
          <span className="text-[12px] text-slate-500">
            par {alert.police_called_by_name || "—"} à {formatTimeFr(alert.police_called_at)}
          </span>
        </div>
      </div>
    );
  }

  const onConfirm = async () => {
    setLoading(true);
    try {
      const updated = await markPoliceCalled(alert.id);
      toast.success("Marqué : police/secours contactés.");
      onUpdated(updated);
      setConfirmOpen(false);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <a
        href="tel:17"
        data-testid="call-17-button"
        className="flex w-full items-center justify-center gap-2.5 rounded-[16px] px-4 py-4 text-[15px] font-bold text-white transition"
        style={{
          background: "#0F172A",
          boxShadow: "0 6px 20px -6px rgba(15,23,42,0.45)",
        }}
      >
        <Phone size={18} strokeWidth={2.4} />
        Appeler le 17
      </a>
      <button
        type="button"
        onClick={() => setConfirmOpen(true)}
        disabled={loading}
        data-testid="police-called-button"
        className="flex w-full items-center justify-center gap-2.5 rounded-[16px] border-2 border-[#0F172A]/15 bg-white px-4 py-3 text-[14px] font-bold transition hover:bg-slate-50 disabled:opacity-70"
        style={{ color: "#7C2D12" }}
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : <ShieldCheck size={16} />}
        {loading ? "Enregistrement…" : "J'ai contacté la police / les secours"}
      </button>

      <ConfirmDialog
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        title="Confirmer le contact des secours ?"
        description="Cela informe l'équipe pour éviter les doublons d'appel au 17."
        confirmLabel="Oui, j'ai appelé"
        cancelLabel="Annuler"
        tone="primary"
        loading={loading}
        onConfirm={onConfirm}
        testId="police-called-confirm"
      />
    </div>
  );
}
